import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ManageSkillsService } from 'src/app/core/services/manage-skills.service';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.css']
})
export class UploadFilesComponent implements OnInit {
  @Input() modalData;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  @ViewChild('viewSkillsSampleFormat') viewSkillsSampleFormatRef: TemplateRef<any>;
  @ViewChild(DropzoneDirective) fileUploadDropZone: DropzoneDirective;

  showFileFormatModal: BsModalRef;

  dropzoneConfig: DropzoneConfigInterface;
  uploadUrl: any;
  fileExistsFlag: boolean = false;
  disableUploadButtonFlag: boolean = false;
  isFileUploaded: boolean = false;
  fileUploadInProgressFlag: boolean = false;

  constructor(
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private skillsService: ManageSkillsService,
    public bsModalService: BsModalService) { }

  ngOnInit() {
    this.getUploadUrl();
    this.dropzoneConfig = this._getDropZoneSettings();
  }

  getUploadUrl() {
    if(this.modalData.type === 'uploadRequisitionEntities') {
      if(this.modalData.action === 'degrees') {
        this.uploadUrl = this.skillsService.getRequisitionEntitiesDegreesUploadUrl();
      } else if(this.modalData.action === 'fieldOfStudy') {
        this.uploadUrl = this.skillsService.getFieldOfStudyUploadUrl();
      } else if(this.modalData.action === 'roles') {
        this.uploadUrl = this.skillsService.getCandidateRolesUploadUrl();
      } else if(this.modalData.action === 'certificates') {
        this.uploadUrl = this.skillsService.getCertificationsUploadUrl();
      } else if(this.modalData.action === 'jdActions') {
        this.uploadUrl = this.skillsService.getJdActionsUploadUrl();
      }
    } else if(this.modalData.type === 'uploadSkills') {
      this.uploadUrl = this.skillsService.getSkillFileUploadUrl();
    }
  }

  onFileAdded(file) {
    this.fileExistsFlag = true;
    const progressElement: HTMLElement = document.querySelector('.dz-progress');
    if (progressElement) {
      progressElement.style.top = '70%';
    }
  }

  onFileRemoved(file) {
    if (this.fileUploadDropZone.dropzone().files.length === 0) {
      this.fileExistsFlag = false;
      this.fileUploadInProgressFlag = false;
      this.disableUploadButtonFlag = false;
      // enable adding of further files if it was disabled
      const hiddenInput: HTMLInputElement = document.querySelector('.dz-hidden-input');
      if (hiddenInput) {
        hiddenInput.disabled = false;
      }
    }
  }

  onFileSending() {
    // disable the upload button to avoid multiple clicks
    this.disableUploadButtonFlag = true;
    this.isFileUploaded = false;
    // indicate that file upload is in progress
    this.fileUploadInProgressFlag = true;
  }

  onFileSuccess(args) {
    const response = args[1];
    // remove file upload in progress flag
    this.fileUploadInProgressFlag = false;
    this.isFileUploaded = true;
    this.fileUploadDropZone.dropzone().clickable = false;
    const hiddenInput: HTMLInputElement = document.querySelector('.dz-hidden-input');
    if (hiddenInput) {
      hiddenInput.disabled = true;
    }
    if (this.saveCallback) {
      this.saveCallback.emit(response);
    }
  }

  onFileError(args) {
    const file = args[0];
    const error = args[1];
    const elements = document.querySelectorAll('.dz-file-preview');
    Array.from(elements).forEach((element) => {
      const filename = element.querySelectorAll('.dz-filename span')[0].textContent;
      const errorMessage = element.querySelectorAll('.dz-error-message span')[0];
      if (filename === file.name) {
        errorMessage.textContent = error.message === undefined ? error : error.message;
      }
    });
    this.fileUploadInProgressFlag = false;
  }

  _getDropZoneSettings(): DropzoneConfigInterface {
    let dropZoneSettings = {};
    dropZoneSettings = {
      url: this.uploadUrl,
      paramName: () => {
        return "files";
      },
      acceptedFiles: ".csv,.xlsx,.xls",
      maxFiles: 1,
      maxFilesize: 10,
      maxThumbnailFilesize: 10,
      timeout: 300000,
      addRemoveLinks: true,
      autoProcessQueue: false,
      uploadMultiple: false
    }
    return dropZoneSettings;
  }

  uploadFile() {
    this.fileUploadDropZone.dropzone().processQueue();
  }

  showFileFormat(template: TemplateRef<any>) {
    const config = new ModalConfig();
    const modalData: any = {};
    config.class = "modal-lg custom-ngx-upload-modal";
    config.initialState = modalData;
    if (this.modalData.type === 'uploadSkills' || this.modalData.type === 'uploadRequisitionEntities') {
      this.showFileFormatModal = this.bsModalService.show(template, config);
    }
  }

  closeFileFormateModal() {
    if (this.showFileFormatModal) {
      this.showFileFormatModal.hide();
    }
  }
}
